import { uuidv7 } from 'uuidv7'

import { HEADERS } from '@/dev'
import keys from '@/config/keys'
import { buildEmmaDomainReferer } from '@/utils/buildEmmaDomainReferer'

/**
 * Keep fetch and Axios requests using the same EMMA routing headers.
 */
export const buildEmmaRequestHeaders = ({ eventId, requestId = true } = {}) => {
	const browserWindow = typeof window !== 'undefined' ? window : null
	const href = browserWindow?.location?.href || ''
	const customReferer = HEADERS[keys.HEADERS.REFERER]
	const headers = {
		[keys.HEADERS.REFERER]: customReferer
			? href.replace(browserWindow?.location?.origin || '', customReferer)
			: href,
		[keys.HEADERS.DOMAIN_REFERER]: buildEmmaDomainReferer(href),
	}

	if (requestId) headers[keys.HEADERS.REQUEST_ID] = uuidv7()
	if (eventId) headers[keys.HEADERS.EVENT_ID] = eventId

	return headers
}
